import type { ExtrasOrdersQuery, LocaleEnum, ProductCategoryDeliverySlot } from '@/gql/myomr'

export { default as BookingOverview } from './BookingOverview.vue'
export { default as BookingSelection } from './BookingSelection.vue'
export { default as CheckoutOrder } from './CheckoutOrder.vue'
export { default as FestivalShopLayout } from './FestivalShopLayout.vue'
export { default as ManageOrders } from './ManageOrders.vue'
export { default as OrderConfirmation } from './OrderConfirmation.vue'
export { default as CategoryProductList } from './Categories/CategoryProductList.vue'
export { default as ProductDetails } from './ProductDetails.vue'
export { getOrderDisplayItems, type ExtrasOrderItem, type ExtrasOrderRawItem } from './orderItems'

export type ExtrasOrderNode = ExtrasOrdersQuery['extrasOrders']['nodes'][number]

export const formatLocalDate = (locale: LocaleEnum, date?: Date | string | null, showYear?: boolean) => {
  if (!date) return '-'
  const value = new Date(date)
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: showYear ? 'numeric' : undefined }).format(value)
}

const formatLocalWeekday = (locale?: LocaleEnum, date?: Date | string | null) => {
  if (!date) return '-'
  return new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(new Date(date))
}

export const formatDeliverySlot = (slot: ProductCategoryDeliverySlot, locale: LocaleEnum) => {
  const startsAt = new Date(slot.startsAt).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
  const endsAt = new Date(slot.endsAt).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
  return `${formatLocalWeekday(locale, slot.startsAt)} (${formatLocalDate(locale, slot.startsAt, true)}), ${startsAt} - ${endsAt}`
}
